import "@/app/globals.css";
import EitaButton from "@/components/base/misc/EitaButton";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";

export default function AuthLayout({ children }) {
    useEffect(() => {
        document.body.className = "auth-layout";
    }, []);

    return (
        <>
            <div
                className="flex justify-center items-start sm:items-center w-full h-full bg-cover overflow-auto"
                style={{
                    backgroundImage: "url(/images/auth-bg.jpg)",
                    backgroundRepeat: "repeat",
                }}
            >
                {children}
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                style={{ bottom: 10, zIndex: 1000001 }}
            />

            <EitaButton />
            <Enamad />
        </>
    );
}

function Enamad() {
    return (
        <Box
            sx={{
                position: "absolute",
                right: 10,
                bottom: 10,
                display: "block",
                width: "60px",
                height: "60px",
                "> a": {
                    display: "block",
                    width: "100%",
                    height: "100%",
                    zIndex: 10000,
                },
                img: {
                    width: "100%",
                    height: "100%",
                },
            }}
            dangerouslySetInnerHTML={{
                __html: `
                <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=479506&Code=wpryrvV9EhutQFmxeLQze77R4F6sKjKl'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=479506&Code=wpryrvV9EhutQFmxeLQze77R4F6sKjKl' alt='' style='cursor:pointer' code='wpryrvV9EhutQFmxeLQze77R4F6sKjKl'></a>
                `,
            }}
        />
    );
}
